export default __webpack_public_path__ + "static/media/bigWheelActive.a0b0fbca.svg";